import { Icon, IconProps } from './Icon';

interface SlowAndRelaxedIconProps extends IconProps {
  gradient?: {
    id: string;
    stops: { offset: string; color: string }[];
  };
}

export const SlowAndRelaxedIcon = ({ color = '#C2E2FF', gradient, ...props }: SlowAndRelaxedIconProps) => (
  <Icon
    {...props}
    viewBox="0 0 46 45"
  >
    <defs>
      {gradient && (
        <linearGradient
          id={gradient.id}
          x1="80%"
          y1="20%"
          x2="20%"
          y2="80%"
        >
          {gradient.stops.map((stop, index) => (
            <stop
              key={index}
              offset={stop.offset}
              stopColor={stop.color}
            />
          ))}
        </linearGradient>
      )}
      <clipPath id="clip0_5287_12447">
        <rect
          width="45"
          height="45"
          fill="white"
          transform="translate(0.5)"
        />
      </clipPath>
    </defs>
    <g clipPath="url(#clip0_5287_12447)">
      <path
        d="M30.8795 19.3415C30.8795 27.1376 23.0071 33.4575 23.0071 33.4575C23.0071 33.4575 15.1348 27.1376 15.1348 19.3415C15.1348 11.5455 23.0071 5.22559 23.0071 5.22559C23.0071 5.22559 30.8795 11.5455 30.8795 19.3415Z"
        fill={gradient ? `url(#${gradient.id})` : color}
      />
      <path
        d="M38.1478 32.5839C32.6352 38.0965 22.5997 36.9987 22.5997 36.9987C22.5997 36.9987 21.502 26.9633 27.0146 21.4507C32.5272 15.938 42.5627 17.0358 42.5627 17.0358C42.5627 17.0358 43.6604 27.0712 38.1478 32.5839Z"
        fill={gradient ? `url(#${gradient.id})` : color}
      />
      <path
        d="M8.01235 32.5839C13.525 38.0965 23.5604 36.9987 23.5604 36.9987C23.5604 36.9987 24.6582 26.9633 19.1455 21.4507C13.6329 15.938 3.59747 17.0358 3.59747 17.0358C3.59747 17.0358 2.49973 27.0712 8.01235 32.5839Z"
        fill={gradient ? `url(#${gradient.id})` : color}
      />
    </g>
  </Icon>
);
